/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CategoryModalEdit from '../Modals/ServicesModalEdit'
import TeamModalEdit from '../Modals/TeamModalEdit'
import FaqVideoEditModal from '../Modals/FaqVideoEditModal'
import { Description } from '@mui/icons-material'
import { useAgencyInfo } from 'context/agency'
import { Roles } from 'enums/user'

//
export default function DataTableData() {
  const AppService = useAppServices()
  const agency = useAgencyInfo()
  const [teams, setTeams] = useState([])
  const [categries, setCategries] = useState([])
  const [loader, setloader] = useState(true)

  const [staff, setStaff] = useState([])
  const getStaff = async () => {
    const { response } = await AppService.user.GetUsers()
    if (response) {
      setStaff(response.data)
    } else {
      setStaff([])
    }
    // setloader(false)
  }

  useEffect(() => {
    getStaff()
  }, [])

  const getTeams = async () => {
    const { response, error } = await AppService.team.get({
      query: ``,
    })

    if (response) {
      setTeams(response.data)
      setloader(false)
    } else {
      setloader(false)
    }
  }
  const onLoad = () => {
    getTeams()
  }

  const handleDeleteTeam = async (id) => {
    const { response } = await AppService.team.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  useEffect(onLoad, [])
  return {
    loader: loader,
    handleRefresh: onLoad,
    staff: staff,
    teamsTable: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'leader', accessor: 'leader' },
        { Header: 'members', accessor: 'members' },

        { Header: 'Action', accessor: 'action' },
      ],

      rows: teams?.map((data, index) => ({
        name: data.name,
        leader: data.leader?.map((item) => {
          return item?.label
        }),
        members: data.members?.map((item) => {
          return item?.label + " - "
        }),
        action: (
          <MDBox>
            <TeamModalEdit staff={staff} handleRefresh={onLoad} editData={data} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDeleteTeam(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },

  }
}
